import React from 'react';

import StatusSummaryWrapper from '../status/statusSummaryWrapper.jsx';
import OnboardingLink from '../status/onboardingLink.jsx';
import partnerPropTypes from '../partnerPropTypes.js';

function getStatusSummary(partner) {
    return `${partner.name} kan betale deg via FINN. For å sette i gang, må ${partner.name} starte Trygg betaling.`;
}

const NotStartedSummary = ({ partner }) => (
    <StatusSummaryWrapper
        skipActionRequired
        statusSummary={getStatusSummary(partner)}
    >
        <div className="centerify">
            <OnboardingLink label="Hva er Trygg betaling?" />
        </div>
    </StatusSummaryWrapper>
);

NotStartedSummary.propTypes = {
    partner: partnerPropTypes.isRequired,
};

export default NotStartedSummary;



// WEBPACK FOOTER //
// ./safeTrade/seller/notStartedSummary.jsx